const {gql} = require('graphql-tag')
export default gql`
  mutation removeArtwork ($id: ID!) {
    removeArtwork (id: $id) {
      id
    }
  }
`
